import { call } from '../@';

export type Payload = { titles: Array<{ number: string; tenure: string; address: string }> };

const getPropertyAvailableDocuments = (payload: Payload) => call('hmlr-getPropertyAvailableDocuments', payload);

export default getPropertyAvailableDocuments;
